import { AppBar, Container, Stack } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import { ContainedButton } from '../Button'
import { SippLogo } from '../icons'

const baseStyle = {
  position: 'relative',
  borderBottom: 'none',
}

export const TestStripHeader = () => {
  const { pathname } = useLocation()
  const backgroundColor = pathname === '/test-strip' ? 'white' : '#F3F6F8'
  const navigate = useNavigate()
  return (
    <AppBar sx={{ ...baseStyle, backgroundColor }} elevation={0}>
      <Container maxWidth="lg">
        <Stack
          width="100%"
          direction="row"
          height={68}
          alignItems="center"
          justifyContent="space-between"
        >
          <SippLogo sx={{ fontSize: '3rem', cursor: 'pointer' }} onClick={() => navigate('/')}/>
          <ContainedButton disableElevation>Get SIPP</ContainedButton>
        </Stack>
      </Container>
    </AppBar>
  )
}
